module.exports = __webpack_public_path__ + "static/media/club.165447d3.svg";